<div class="admin-modal dst-form-create-edit-modal">
  <div class="modal-header">
    <h3 class="modal-title">{{ modalTitle }}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         title="{{ minimise ? 'Restore' : 'Minimise' }}"
         (click)="minimise = !minimise"></i>
      <i class="fa fa-times" title="Close" (click)="cancel()"></i>
    </div>
  </div>

  <div class="modal-body" [hidden]="minimise">
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
}

    @if (!showFormLoader && lookups) {
<form class="dst-form" #dstForm="ngForm" novalidate>
      <div class="form-row">
        <div class="form-label-col">
          <label for="form-name">Form Name:<span class="required">*</span></label>
        </div>
        <div class="form-control-col">
          <input id="form-name" type="text" class="form-control" name="formName"
                 [(ngModel)]="formModel.FORMNAME" required
                 [class.field-error]="submitted && !formModel.FORMNAME?.trim()" />
        </div>
      </div>

      @if (isEdit) {
<div class="form-row">
        <div class="form-label-col">
          <label for="form-order">Form Order:<span class="required">*</span></label>
        </div>
        <div class="form-control-col form-control-col--narrow">
          <input id="form-order" type="text" class="form-control" name="formOrder"
                 [(ngModel)]="formModel.FORMORDER" required
                 [class.field-error]="submitted && !formModel.FORMORDER?.trim()" />
        </div>
      </div>
}

      <div class="form-row">
        <div class="form-label-col">
          <label for="sec-number">Section Number:</label>
        </div>
        <div class="form-control-col form-control-col--narrow">
          <input id="sec-number" type="text" class="form-control" name="secNumber"
                 [(ngModel)]="formModel.SECTION_NUMBER" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-label-col">
          <label for="form-type">{{ formTypeLabel }}:<span class="required">*</span></label>
        </div>
        <div class="form-control-col">
          <select id="form-type" class="form-control" name="formType"
                  [(ngModel)]="formModel.PRIMARYFORMTYPEDESC" required
                  [class.field-error]="submitted && (!formModel.PRIMARYFORMTYPEDESC || formModel.PRIMARYFORMTYPEDESC.trim() === '')">
            @for (opt of lookups.formTypes; track $index) {
<option [value]="opt.value">{{ opt.label }}</option>
}
          </select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-label-col">
          <label for="sig-type">Signature Type:<span class="required">*</span></label>
        </div>
        <div class="form-control-col">
          <select id="sig-type" class="form-control" name="sigType"
                  [(ngModel)]="formModel.SIGNATURE_FLAG" required
                  [class.field-error]="submitted && (!formModel.SIGNATURE_FLAG || formModel.SIGNATURE_FLAG.trim() === '')">
            @for (opt of lookups.yesNo; track $index) {
<option [value]="opt.value">{{ opt.label }}</option>
}
          </select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-label-col">
          <label for="elec-type">Election Type:<span class="required">*</span></label>
        </div>
        <div class="form-control-col">
          <select id="elec-type" class="form-control" name="elecType"
                  [(ngModel)]="formModel.ELECTION_FLAG" required
                  [class.field-error]="submitted && (!formModel.ELECTION_FLAG || formModel.ELECTION_FLAG.trim() === '')">
            @for (opt of electionTypeOptions; track $index) {
<option [value]="opt.value">{{ opt.label }}</option>
}
          </select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-label-col">
          <label for="elec-term">Election Term:</label>
        </div>
        <div class="form-control-col">
          <input id="elec-term" type="text" class="form-control" name="elecTerm"
                 [(ngModel)]="formModel.ELECTION_TERM" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-label-col">
          <label for="prim-form-status">{{ formStatusLabel }}:<span class="required">*</span></label>
        </div>
        <div class="form-control-col">
          <select id="prim-form-status" class="form-control" name="primFormStatus"
                  [(ngModel)]="formModel.PRIMARY_FORM_ACTIVE" required
                  [class.field-error]="submitted && (!formModel.PRIMARY_FORM_ACTIVE || formModel.PRIMARY_FORM_ACTIVE.trim() === '')">
            @for (opt of lookups.formStatuses; track $index) {
<option [value]="opt.value">{{ opt.label }}</option>
}
          </select>
        </div>
      </div>

      @if (isEdit) {
<div class="form-row">
        <div class="form-label-col">
          <label for="sec-form-type">Secondary Form Type:<span class="required">*</span></label>
        </div>
        <div class="form-control-col">
          <select id="sec-form-type" class="form-control" name="secFormType"
                  [(ngModel)]="formModel.SECONDARYFORMTYPEDESC" required
                  [class.field-error]="submitted && (!formModel.SECONDARYFORMTYPEDESC || formModel.SECONDARYFORMTYPEDESC.trim() === '')">
            @for (opt of lookups.formTypes; track $index) {
<option [value]="opt.value">{{ opt.label }}</option>
}
          </select>
        </div>
      </div>
}

      @if (isEdit) {
<div class="form-row">
        <div class="form-label-col">
          <label for="sec-form-status">Secondary Form Status:<span class="required">*</span></label>
        </div>
        <div class="form-control-col">
          <select id="sec-form-status" class="form-control" name="secFormStatus"
                  [(ngModel)]="formModel.SECONDARY_FORM_ACTIVE" required
                  [class.field-error]="submitted && (!formModel.SECONDARY_FORM_ACTIVE || formModel.SECONDARY_FORM_ACTIVE.trim() === '')">
            @for (opt of lookups.formStatuses; track $index) {
<option [value]="opt.value">{{ opt.label }}</option>
}
          </select>
        </div>
      </div>
}

      <div class="form-row">
        <div class="form-label-col">
          <label for="attach-name">Attachment Name:<span class="required">*</span></label>
        </div>
        <div class="form-control-col">
          <input id="attach-name" type="text" class="form-control" name="attachName"
                 [(ngModel)]="formModel.ATTACHMENT_NAME" required
                 [class.field-error]="submitted && !formModel.ATTACHMENT_NAME?.trim()" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-label-col">
          <label for="dc-action-flag">DataCollect Action Flag</label>
        </div>
        <div class="form-control-col">
          <select id="dc-action-flag" class="form-control" name="dcActionFlag"
                  [(ngModel)]="formModel.DATACOLLECT_ACTION_FLAG">
            @for (opt of dataCollectActionFlagOptions; track $index) {
<option [value]="opt.value">{{ opt.label }}</option>
}
          </select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-label-col">
          <label for="dc-action-exp">DataCollect Action Explanation</label>
        </div>
        <div class="form-control-col">
          <input id="dc-action-exp" type="text" class="form-control" name="dcExplanation"
                 [(ngModel)]="formModel.DATACOLLECT_ACTION_EXPL" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-label-col">
          <label for="primary-type">Primary Type:<span class="required">*</span></label>
        </div>
        <div class="form-control-col form-control-col--narrow">
          <input id="primary-type" type="text" class="form-control" name="primaryType"
                 [(ngModel)]="formModel.PRIMARY_TYPE" required
                 [class.field-error]="submitted && !formModel.PRIMARY_TYPE?.trim()" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-label-col">
          <label for="secondary-type">Secondary Type:<span class="required">*</span></label>
        </div>
        <div class="form-control-col form-control-col--narrow">
          <input id="secondary-type" type="text" class="form-control" name="secondaryType"
                 [(ngModel)]="formModel.SECONDARY_TYPE" required
                 [class.field-error]="submitted && !formModel.SECONDARY_TYPE?.trim()" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-label-col">
          <label for="tertiary-type">Tertiary Type:<span class="required">*</span></label>
        </div>
        <div class="form-control-col form-control-col--narrow">
          <input id="tertiary-type" type="text" class="form-control" name="tertiaryType"
                 [(ngModel)]="formModel.TERTIARY_TYPE" required
                 [class.field-error]="submitted && !formModel.TERTIARY_TYPE?.trim()" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-label-col">
          <label for="key-diagnostic">Key Diagnostic:</label>
        </div>
        <div class="form-control-col form-control-col--medium">
          <input id="key-diagnostic" type="text" class="form-control" name="keyDiagnostic"
                 [(ngModel)]="formModel.KEY_DIAGNOSTIC" />
        </div>
      </div>
    </form>
}
  </div>

  <div class="modal-footer controls-container" [hidden]="minimise">
    <button type="button" class="btn btn-warning" (click)="save()" [disabled]="crudLoading || showFormLoader">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
      Save
    </button>
    <button type="button" class="btn btn-info" (click)="cancel()" [disabled]="crudLoading">Cancel</button>
  </div>
</div>
